export function addBanHeroPersona(hero){
    return{
        type:'ADD_BAN_HERO_PERSONA',
        payload:hero
    }
}